import(/* webpackMode: "eager" */ "/codebuild/output/src4239905409/src/apps/webapp/src/app/global-error.tsx");
